module.exports = __webpack_public_path__ + "img/IMG-20200301-WA0304.4bb5f37e.jpg";